module.exports = __webpack_public_path__ + "static/img/cooperator.cdbef96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serie_a/cooperator.png
// module id = HjEM
// module chunks = 1